import { Injectable } from "@angular/core";
import { QueryEntity } from "@datorama/akita";
import { TierState, TierStore } from "./tier.store";
import { LoyaltyTier } from "./models/tier.model";
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TierQuery extends QueryEntity<TierState, LoyaltyTier> {

  customerTier$ = this.select((state) => state.tier);
  tiers$ = this.selectAll();

  constructor(protected store: TierStore) {
    super(store);
  }

  /**
   * Gets the current tier id of the customer
   * @returns the current tier id
   */
  getCurrentTierId(){
    return this.getValue().tier?.CurrentTierId;
  }

  /**
   * Gets the current tier of the customer tiers list
   */
  getCurrentTier(): Observable<LoyaltyTier | undefined>{
    return this.select(state => state.tier?.Tiers.find(tier => tier.TierId === state.tier?.CurrentTierId));
  }

  /**
   * Gets the tier by id
   * @param id 
   */
  getTierById(id: number): LoyaltyTier | undefined{
    return this.getEntity(id);
  }

  /**
   * Selects the tier by id
   * @param id 
   */
  selectTierById(id: number): Observable<LoyaltyTier | undefined>{
    return this.selectEntity(id);
  }

}